import React from 'react';
import SigninHeader from 'Components/Account/SigninHeader'
import Footer from './Footer';

function PrivacyPolicy() {
  return (
    <div className='w-full h-full  '>
       <SigninHeader/>
       <div className='col-span-6 lg:text-xl flex justify-center items-center w-full'>
       <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800">
        <h1 className="lg:text-xl font-bold mb-6">Privacy Policy</h1>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Introduction</h2>
          <p className="mb-2">
            1.1 This Privacy Policy explains how Quick Case Review ("we", "us", "our") collects, uses,
            discloses, and protects your personal information when you use our website <a href="https://www.quickcasereview.com" className="text-blue-600 underline">https://www.quickcasereview.com</a> ("Site").
          </p>
          <p className="mb-2">
            1.2 By accessing or using our Site, you agree to the terms of this Privacy Policy.
          </p>
          <p>1.3 This Privacy Policy is effective as of April 5, 2025.</p>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Information We Collect</h2>
          <p className="mb-2 font-semibold">2.1 Personal Information:</p>
          <ul className="list-disc list-inside space-y-1 mb-4">
            <li>2.1.1 Name (if provided)</li>
            <li>2.1.2 Email address</li>
            <li>2.1.3 Phone number</li>
            <li>2.1.5 Case information (for Leads)</li>
            <li>2.1.6 Employment information (for Attorneys and Legal Assistants)</li>
            <li>2.1.7 Images (for Attorneys and Legal Assistants)</li>
          </ul>

          <p className="mb-2 font-semibold">2.2 Automatically Collected Information:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>2.2.1 IP address</li>
            <li>2.2.2 Device or browser</li>
            <li>2.2.3 Operating system</li>
            <li>2.2.4 Pages viewed</li>
            <li>2.2.5 Time spent on Site</li>
            <li>2.2.6 Login information</li>
            <li>2.2.7 Geographical location</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">How We Use Your Information</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>3.1.1 Provide and improve our lead organization services</li>
            <li>3.1.2 Communicate with you about our services</li>
            <li>3.1.3 Respond to your inquiries and requests</li>
            <li>3.1.4 Comply with legal obligations</li>
            <li>3.1.5 Advertise services or products to you</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Information Sharing and Disclosure</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>4.1.1 Service providers who assist in our operations</li>
            <li>4.1.2 Law enforcement or government agencies, as required by law</li>
            <li>4.1.3 Other parties with or without your consent</li>
            <li>4.1.4 Third-party advertising agencies</li>
            <li>4.1.5 Third-party companies for advertising purposes</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Your California Privacy Rights</h2>
          <p className="mb-2">5.1 If you are a California resident, you have the right to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes.</p>
          <p>5.2 To make such a request, please contact us using the information provided in Section 9.</p>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Data Security</h2>
          <p>6.1 We implement reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.</p>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Your Rights and Choices</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>7.1.1 Access your personal information</li>
            <li>7.1.2 Correct inaccurate information</li>
            <li>7.1.3 Delete your personal information</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Changes to This Privacy Policy</h2>
          <p>8.1 We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the updated policy on our Site.</p>
        </section>

        <section className="mb-8">
          <h2 className="lg:text-xl font-semibold mb-2">Contact Us</h2>
          <p>9.1 If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@quickcasereview.com" className="text-blue-600 underline">info@quickcasereview.com</a>.</p>
        </section>
      </div>
       </div>
       <Footer/>
    </div>
  )
}

export default PrivacyPolicy
    